import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import useSession from '@hooks/useSession';

interface ExportToExcelButtonProps {
  onClick: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const ExportToExcelButton = ({ onClick, disabled = false, style }: ExportToExcelButtonProps) => {
  const { isUser, isManager, isAdmin, isSuperAdmin } = useSession();

  if (!isUser && !isManager && !isAdmin && !isSuperAdmin) return null;

  return (
    <Button
      icon={<DownloadOutlined />}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      Export to Excel
    </Button>
  );
};

export default ExportToExcelButton;
